module.exports = __webpack_public_path__ + "static/media/download-mini.35748991.svg";